@if (!isAccessFlagLoading && !isUrlVerified) {
  <app-url-verification
    [hasAccess]="outlookAddInAccessEnabled"
    [noAccessMessage]="featureFlagErrorText | translate"
    [tenantApiBaseUrl]="tenantService.BASE_URL"
    (successfulVerificationEvent)="onSuccessfulVerification()"
    (mustSignOutEvent)="signOut()"
  ></app-url-verification>
} @else {
  @if (!isLoading && user) {
    <app-banner
      class="w-full flex-shrink-0"
      [title]="'sendToEtrieve' | translate"
      [user]="user"
      [isWebApps]="isWebApps"
      [isOutlook]="isOutlook"
      (changeContentUrlEvent)="changeContentUrl()"
    >
    </app-banner>
    @if (isProcessingMessage) {
      <div class="loading-screen">
        <p class="loading-text">{{ 'loadingDocuments' | translate }}</p>
        <img
          src="./assets/images/leaf.svg"
          class="leaf-image"
          alt="Leaf Icon"
        />
      </div>
    } @else {
      <div class="capture-container">
        <app-capture
          parentType="outlook"
          (restartFilingEvent)="closeDialog()"
        ></app-capture>
      </div>
    }
  }
}
<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        @if (message.data) {
          <span>{{ message.data }}</span>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
